module.exports = __webpack_public_path__ + "img/settings_active.040b0f22.svg";